import React from "react";

var pinSvg = function pinSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13 9H3V8a1 1 0 0 1 1-1h.5L4.934.929A1 1 0 0 1 5.93 0h4.138a1 1 0 0 1 .997.929L11.5 7h.5a1 1 0 0 1 1 1zm-4.63 6.625A.375.375 0 0 1 8 16h-.005a.375.375 0 0 1-.375-.375c0-.056-.113-1.598-.339-4.625H8.72a700.167 700.167 0 0 0-.349 4.625z",
    fillRule: "evenodd"
  }));
};

pinSvg.defaultProps = {
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
};
export var pin = {
  category: 'icon',
  colorable: true,
  name: 'pin',
  svg: pinSvg
};